export default {
	SET_POSTERS_SELECTED(state, selectedPosters) {
		state.selectedPosters = selectedPosters;
	},
};


// WEBPACK FOOTER //
// ./resources/assets/js/components/store/print-posters/mutations.js